import banner from './modules/banner';
import kingKong from './modules/kingkong';
import taskList from './modules/task-list';

export default {
	namespaced: true,
	state: () => ({}),
	mutation: {},
	actions: {},
	getters: {},

	//	嵌套模块,继承父模块的命名空间
	modules: {
		banner,
		kingKong,
		taskList,
	},
};



// WEBPACK FOOTER //
// ./src/store/Task/index.js